import { z } from "zod";

const schema = z
  .object({
    jobTitle: z
      .string({ required_error: "Job title is required" })
      .min(1, "Job title is required"),
    jobDescription: z
      .instanceof(File, {
        message: "Job description is required",
      })
      .optional(),
    maskedJobDescription: z
      .instanceof(File, {
        message: "Job description is required",
      })
      .optional(),
    briefDescription: z
      .string({
        required_error: "You must provide a brief description of the job",
      })
      .min(1, "You must provide a brief description of the job"),
    goals: z
      .string({
        required_error: "You must provide a summary of what you're looking for",
      })
      .min(1, "You must provide summary of what you're looking for"),
    budgetMinCents: z
      .number()
      .int()
      .min(1, { message: "A minimum budget is required" })
      .nullable()
      .refine((v) => v !== null, { message: "A minimum budget is required" }),
    budgetMaxCents: z
      .number()
      .int()
      .min(1, { message: "A maximum budget is required" })
      .nullable()
      .refine((v) => v !== null, { message: "A maximum budget is required" }),
    budgetNotes: z.string().optional(),
    idealStartDate: z.date({ required_error: "Ideal start date is required" }),
    matchCriteria: z.array(z.string()).length(3),
    additionalInformation: z.string().optional(),
  })
  .refine((data) => data.budgetMinCents <= data.budgetMaxCents, {
    message: "Maximum budget cannot be less than minimum budget",
    path: ["budgetMaxCents"],
  });

type Schema = z.infer<typeof schema>;

export {
  schema as companyOpportunityFormSchema,
  type Schema as CompanyOpportunityFormSchema,
};
